module.exports = __webpack_public_path__ + "media/images/banner/klook/sp/rental-o_360_360_ja-bd7d56e3285d5cfdf183f6cbdd9e4e8c.jpg";